import type { TenantConfig } from '@/types/TenantConfig'

export const meowwolf: TenantConfig = {
  logo: {
    large: 'assets/meowwolf/static/logo.svg',
    small: 'assets/meowwolf/static/mobile-logo.svg',
  },
  themeOptions: {
    dialog: {
      headerBackground: '#000000',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
      headerBorder: '0',
    },
    mobileFooter: {
      cartButtonIconColor: '#000000',
      cartButtonBorder: '2px solid #000000',
      textColor: '#000000',
      priceTextColor: '#000000',
    },
  },
  titleInsideContentColumn: true,
  teaserImageSize: {
    height: 200,
  },
  componentOptions: {
    cartWidget: {
      dateTimeFormat: 'ddd, MMM Do, YYYY',
    },
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&display=swap',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/meowwolf/static/images/complete-wide.jpg',
        mobile: 'assets/meowwolf/static/images/complete.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
  i18nOverrides: {
    en: {
      accountLinks: {
        registerLinkShortLabel: 'Annual Passes',
        registerLinkLongLabel: 'Annual Passes',
      },
    },
  },
}
